import { LeftOutlined } from '@ant-design/icons';
import {
    DASHBOARD_URL,
    USER_MANAGEMENT_FULL_URL,
    USER_MANAGEMENT_ROLE_URL,
    USER_MANAGEMENT_URL,
} from '@src/constants/URLS.const';
import { Button, Typography } from 'antd';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import RoleDetailsContent from './component/RoleDetailsContent';
import { UsersList } from '../../Users';
import { useGetRoleByIdQuery } from '@src/services/role/roleById/roleByIdApiSlice';
import { useGetRoleUsersQuery } from '@src/services/role/roleUsers/roleUsersApiSlice';
import { useTranslation } from 'react-i18next';
import { PencilSquareIcon } from '@heroicons/react/16/solid';
import { ActionGuard } from '@src/components/permissions';
import { FormSkeleton } from '@src/components';
const { Text } = Typography;

export default function RolesDetailsPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { roleId } = useParams();
    const [searchParams] = useSearchParams();

    const isReadonly = searchParams.get('readonly') === 'true';
    const {
        data: roleById,
        isLoading,
        error,
    } = useGetRoleByIdQuery({
        roleId: roleId ?? '',
    });
    const {
        data: roleUsers,
        isLoading: isLoadingUsers,
        error: getUsersError,
    } = useGetRoleUsersQuery({
        roleId: roleId ?? '',
        limit: 50,
    });

    if (isLoading || isLoadingUsers) return <FormSkeleton />;

    return (
        <div className="flex flex-col gap-6 ">
            <div className="flex justify-between w-full ">
                <div className=" flex items-center gap-2">
                    <Button
                        variant="outlined"
                        iconPosition="start"
                        icon={<LeftOutlined />}
                        className="btn-secondary border"
                        onClick={() =>
                            navigate(
                                `${USER_MANAGEMENT_FULL_URL}/${USER_MANAGEMENT_ROLE_URL}`
                            )
                        }
                    />
                    <Text className="text-[16px]">
                        {t('pages.role.details.title')}
                    </Text>
                </div>
                {!isReadonly && (
                    <ActionGuard module="RoleManagement">
                        <Button
                            className="btn-tertiary"
                            variant="outlined"
                            icon={<PencilSquareIcon width={16} height={16} />}
                            onClick={() =>
                                navigate(
                                    `${DASHBOARD_URL}/${USER_MANAGEMENT_URL}/${USER_MANAGEMENT_ROLE_URL}/edit/${roleId}`
                                )
                            }
                        >
                            {t('dataTableRowActions.edit')}
                        </Button>
                    </ActionGuard>
                )}
            </div>
            <RoleDetailsContent
                roleName={roleById?.data.name ?? ''}
                assignedUsers={roleUsers?.data.items.length ?? 0}
                description={roleById?.data.description ?? ''}
            />
            <UsersList roleId={roleId} />
        </div>
    );
}
